import { render, staticRenderFns } from "./CloudHome.vue?vue&type=template&id=0570a586&scoped=true&"
import script from "./CloudHome.vue?vue&type=script&lang=js&"
export * from "./CloudHome.vue?vue&type=script&lang=js&"
import style0 from "./CloudHome.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CloudHome.vue?vue&type=style&index=1&id=0570a586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0570a586",
  null
  
)

export default component.exports